import { useEffect, useRef } from 'react';

export const useInterval = (callback, delay) => {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (delay !== null) {
      const handler = (...args) => savedCallback.current(...args);
      const id = setInterval(handler, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
};
